export const TEETH_LIST_FIELDS = [
  'missing-teeth',
  'teeth-lost',
  'teeth-moved',
  'teeth-moving',
  'teeth-hurt',
  'teeth-fract-without-lesion',
  'teeth-fract-with-lesion',
  'teeth-root-fract',
  'lamal-not-cured',
  'lamal-cured',
  'lamal-lesion',
  'teeth-been-replaced',
  'defective-teeth',
  'repaired-teeth',
  'periodontal-teeth',
  'dental-schema-teeth',
];

export function normalizeTeethList(value) {
  if (value == null || value === '') {
    return '';
  }
  if (typeof value !== 'string') {
    return String(value);
  }
  return value
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean)
    .join(',');
}

export function parseTeethList(value) {
  const normalized = normalizeTeethList(value);
  return normalized ? normalized.split(',') : [];
}

export function normalizeTeethListFields(data) {
  if (!data || typeof data !== 'object') {
    return data;
  }

  const normalized = { ...data };
  for (const field of TEETH_LIST_FIELDS) {
    if (field in normalized && normalized[field]) {
      normalized[field] = normalizeTeethList(normalized[field]);
    }
  }
  return normalized;
}
